import { createFileRoute } from "@tanstack/react-router";
import { ChangePasswordForm } from "components/Forms/ChangePasswordForm/ChangePasswordForm.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const Route = createFileRoute("/$tenantSlug/auth/_layout/change-password/")({
    component: ChangePasswordPage,
});

function ChangePasswordPage() {
    const { t: tAuth } = usePaldockTranslation("auth.change-password");
    const { tenantSlug } = Route.useParams();

    return (
        <AuthPageContainer title={tAuth("title")}>
            <ChangePasswordForm tenantSlug={tenantSlug} />
        </AuthPageContainer>
    );
}
